// extracted by mini-css-extract-plugin
module.exports = {"description":"_2nZPz","brand":"_2jIm8","brandLogo":"DAaFJ","follow":"_10_K9","logo":"_3vJ5i","panelWrapper":"FUwP1","panel":"_3jl7Q"};